'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _browserProvider = require('react-router-redux-saga-model/libs/browser-provider');

var _browserProvider2 = _interopRequireDefault(_browserProvider);

var _controllerBindModel = require('./controller-bind-model');

var _controllerBindModel2 = _interopRequireDefault(_controllerBindModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserMVC = function (_React$Component) {
  (0, _inherits3.default)(BrowserMVC, _React$Component);

  function BrowserMVC() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BrowserMVC);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BrowserMVC.__proto__ || (0, _getPrototypeOf2.default)(BrowserMVC)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'BrowserMVC', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BrowserMVC, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          modelRegister = _props.modelRegister,
          others = (0, _objectWithoutProperties3.default)(_props, ['modelRegister']);

      return _react2.default.createElement(
        _browserProvider2.default,
        others,
        _react2.default.createElement(_controllerBindModel2.default, {
          basename: others.basename,
          hot: others.hot,
          modelRegister: modelRegister
        })
      );
    }
  }]);
  return BrowserMVC;
}(_react2.default.Component);

exports.default = BrowserMVC;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mvc-react/libs/browser-mvc.js
// module id = 1208
// module chunks = 0